// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"645": "GuestLazyComponent","787": "BadgeTooltipV1",}[chunkId] + "." + {"645": "92227cb1544fd468","787": "7a9decf519d7e12e",}[chunkId] + ".js"
}